import { render, staticRenderFns } from "./LoadImage.vue?vue&type=template&id=490f96a5"
import script from "./LoadImage.vue?vue&type=script&lang=ts"
export * from "./LoadImage.vue?vue&type=script&lang=ts"
import style0 from "./LoadImage.vue?vue&type=style&index=0&id=490f96a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports